var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.918 1.605C4.863.66 5.995.188 7.312.188c1.318 0 2.45.472 3.395 1.417.945.946 1.418 2.077 1.418 3.395 0 .802-.2 1.561-.602 2.277a4.481 4.481 0 0 1-1.546 1.72 6.922 6.922 0 0 1 3.05 2.534c.774 1.117 1.16 2.378 1.16 3.781h-1.374c0-1.518-.545-2.807-1.633-3.867-1.06-1.088-2.35-1.633-3.867-1.633-1.519 0-2.822.545-3.91 1.633-1.06 1.06-1.59 2.35-1.59 3.867H.438c0-1.403.386-2.664 1.16-3.78a6.922 6.922 0 0 1 3.05-2.536 4.832 4.832 0 0 1-1.59-1.719A4.868 4.868 0 0 1 2.5 5c0-1.318.473-2.45 1.418-3.395Zm5.8.989c-.658-.688-1.46-1.031-2.405-1.031-.946 0-1.762.343-2.45 1.03-.659.66-.988 1.462-.988 2.407 0 .945.33 1.762.988 2.45a3.42 3.42 0 0 0 2.45.987c.945 0 1.747-.329 2.406-.988.687-.687 1.031-1.504 1.031-2.449 0-.945-.344-1.747-1.031-2.406Z",
    fill: "currentColor"
  })));
};

export default SvgUser;